import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__field_graph_interaction } from '@shared/dto/generation/graph_invoke/_fields/_base/_enums/ENUM__field_graph_interaction';
import { FN_FIELD__get_fields_map_with_graph_interaction } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/FN_FIELD__get_fields_map_with_graph_interaction';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_base_generic';
import { G_GRAPH_FIELD__row } from './G_GRAPH_FIELD__row';

interface PROPS {
  field: FIELD__list_base_generic<any>;
  field_parent: DTO__base;
}

export function G_GRAPH_FIELD__row_list({ field, field_parent }: PROPS) {
  /*
   * RENDERS
   */
  function render_item(field_child: FIELD__base, index: number) {
    let target_interaction = [ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE];

    if (!target_interaction.includes(field_child.meta.graph__interaction)) return null;

    let fields_connectable = FN_FIELD__get_fields_map_with_graph_interaction(field_child, target_interaction, true);

    return (
      <div key={field_child.meta.field_id}>
        <G_GRAPH_FIELD__row key={field_child.meta.field_id} field={field_child} is_list_item field_parent={field} />

        {fields_connectable.values().map(field_connectable => (
          <G_GRAPH_FIELD__row key={field_connectable.meta.field_id} field={field_connectable} field_parent={field_child} />
        ))}

        {index < field.items.length - 1 && <div className="border-b border-dashed border-component-border" />}
      </div>
    );
  }

  /*
   * HTML
   */
  return (
    <div className="info_field_row_list w-full">
      <div className="shadow-[0px_0px_0px_0.5px_theme(colors.gray.600)]" />

      <G_GRAPH_FIELD__row key={field.meta.field_id} {...{ field, field_parent }} />

      {field.items.map(render_item)}

      <div className="shadow-[0px_0px_0px_0.5px_theme(colors.gray.600)]" />
    </div>
  );
}
